import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '6',
  label: 'Clinical Volumes'
}, {
  value: '4',
  label: 'Professional Bonuses'
}, {
  value: '460+',
  label: 'Pages of Content'
}, {
  value: '🌎',
  label: 'Countries Worldwide'
}];
import { useEffect } from 'react';
export function Hero() {
  useEffect(() => {
    const imgUrl = "https://cdn.magicpatterns.com/uploads/bxHCm6U5yx5mF7DbYjE84Z/ChatGPT-Image-25-jul-2026_-09_12_14-p.m..webp";
    if (!document.querySelector(`link[href="${imgUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = imgUrl;
      link.fetchPriority = 'high';
      document.head.appendChild(link);
    }
  }, []);
  return <section className="w-full bg-off-white px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-104" data-mp="neazje4mrpqf">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-105" data-mp="3d2tnz8hi2ie0">
        <span className="mb-6 inline-block rounded-full border border-sage bg-sage/15 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-dark-green" data-id="element-106" data-mp="381nvnbrr4x50">
          🌿 Premium Digital System for Nutrition Professionals · Global 2026 Edition
        </span>

        <h1 className="font-serif-display text-[24px] font-bold leading-tight text-slate sm:text-5xl md:text-6xl" data-id="element-107" data-mp="39ausbgoyhsyt">
          Stop spending hours on consultation prep. Get everything ready in just 5 minutes.
        </h1>

        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-108" data-mp="30gzuktq5z4t7">
          <div className="relative overflow-hidden rounded-[26px] bg-off-white shadow-[0_20px_45px_-22px_rgba(61,61,61,0.28)]" data-id="element-109" data-mp="3599iy5bmrwtd">
            <img src="https://cdn.magicpatterns.com/uploads/bxHCm6U5yx5mF7DbYjE84Z/ChatGPT-Image-25-jul-2026_-09_12_14-p.m..webp" alt="Nutrition professional with the NutriPro Complete System in her practice" width="1365" height="768" fetchPriority="high" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-110" data-mp="2ql6a8o67e70v" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-white/45" aria-hidden="true" data-id="element-111" data-mp="n98dxp26z7of" />
            <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-off-white/55 to-transparent sm:w-14" aria-hidden="true" data-id="element-112" data-mp="ddngm482ivl0" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-off-white/55 to-transparent sm:w-14" aria-hidden="true" data-id="element-113" data-mp="1ayt8l57pjtdj" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-dark-green/80" data-id="element-114" data-mp="111ew1gownoqi">
            The complete system, ready for your next consultation.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-[12px] text-slate/70 sm:text-base" data-id="element-115" data-mp="3luiawvasv7nh">
          6 Clinical Volumes + 4 Professional Bonuses. 460 pages of evidence-based clinical content.
          Ready to download today. Available from any country worldwide.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-116" data-mp="21aejjiz1mpbo">
          <CTAButton label="GET INSTANT ACCESS NOW" data-id="element-117" data-mp="21b62nubgeul2" />
          <p className="mt-3 text-xs text-slate/60 sm:text-sm" data-id="element-118" data-mp="269r4fy6ctmbm">
            Instant Access · Downloadable PDF · One-Time Payment · No Subscription
          </p>
          <p className="mt-2 text-xs font-medium text-dark-green" data-id="element-119" data-mp="2b2kaqqhh12pt">
            💱 The platform automatically converts to your local currency
          </p>
        </div>

        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-sage/30 bg-white sm:mt-9 sm:grid-cols-4" data-id="element-120" data-mp="2kxc5lmjo5bgw">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-sage/20' : ''} ${index >= 2 ? 'border-t border-sage/20' : ''} sm:border-t-0 sm:border-l sm:first:border-l-0`} data-id="element-121" data-mp="2tyino01yuuc9" data-mpi={index}>
              <span className="font-serif-display text-4xl font-bold text-sage" data-id="element-122" data-mp="49t4lwvct2tx">{metric.value}</span>
              <span className="mt-1 text-xs font-medium text-slate sm:text-sm" data-id="element-123" data-mp="3vh5jg58rl46o">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}